/* Print Phuket – custom quantity cart guard (22 Oct 2026). Loaded on every page.
   A custom quantity is a pack line (qty 1, property "_pp_cq" with a token) plus an "additional pieces" line
   (_pp_own = cq, _pp_cq_tok = same token). Linked by token, not Shopify nesting (the options app's price add-ons
   swallow nested lines). This keeps the pair consistent:
   - quantity changes on either line are refused with a clear message (change the quantity on the product page);
     removing the pack also removes its additional pieces
   - an additional-pieces line that is not attached to its pack, has the wrong quantity or the wrong rate is removed
   - a pack whose additional pieces were removed loses its "Total quantity" note, so production never sees a wrong count
   This is a convenience/consistency layer. Orders are still checked by staff (Flow tag) before production. */
(function () {
  'use strict';
  if (window.__ppCQCart) return; window.__ppCQCart = true;
  var f = window.fetch;
  var MSG = 'This is a custom quantity. To change it, open the product page and enter the new quantity, or remove the item.';
  function cart() { return f.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function isChild(it) { return !!it && ((it.properties && it.properties._pp_own === 'cq') || it.product_type === 'Custom quantity'); } // any additional-pieces line, tagged or not
  function meta(it) { try { return it && it.properties && it.properties._pp_cq ? JSON.parse(it.properties._pp_cq) : null; } catch (e) { return null; } }
  function post(url, body) { return f.call(window, url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), __pp: 1 }); }
  function refreshUI() {
    try { // never loop: at most 2 automatic page reloads per 30 s
      var k = 'pp-cq-reload', a = JSON.parse(sessionStorage.getItem(k) || '[]').filter(function (t) { return Date.now() - t < 30000; });
      if (a.length >= 2) return; a.push(Date.now()); sessionStorage.setItem(k, JSON.stringify(a));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!document.querySelector('cart-drawer[open], cart-drawer.active') } }));
    if (/^\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function sweep() {
    return cart().then(function (c) {
      var items = c.items || [], byKey = {}, fixes = [];
      items.forEach(function (it) { byKey[it.key] = it; });
      items.forEach(function (it) {
        if (!isChild(it)) return;
        var tok = it.properties && it.properties._pp_cq_tok, p = null, m = null;
        items.forEach(function (x) { var mx = meta(x); if (tok && mx && mx.tok === tok) { p = x; m = mx; } });
        var ok = p && m && p.quantity === 1 && it.variant_id === m.xvid && it.quantity === m.extra && m.extra >= 1 && m.extra <= m.max && p.variant_id === m.packVid;
        if (!ok) fixes.push(['remove', it]);
      });
      items.forEach(function (it) {
        var m = meta(it); if (!m) return;
        var kids = items.filter(function (k) { return isChild(k) && k.properties && k.properties._pp_cq_tok === m.tok; });
        if (!kids.length || it.quantity !== 1) fixes.push(['unlabel', it]);
      });
      if (!fixes.length) return false;
      var chain = Promise.resolve();
      fixes.forEach(function (x) {
        chain = chain.then(function () {
          if (x[0] === 'remove') return post('/cart/change.js', { id: x[1].key, quantity: 0 });
          var props = Object.assign({}, x[1].properties); delete props._pp_cq; delete props['Total quantity'];
          return post('/cart/change.js', { id: x[1].key, quantity: x[1].quantity, properties: props });
        });
      });
      return chain.then(function () { return true; });
    }).catch(function () { return false; });
  }

  function refusal() {
    var body = JSON.stringify({ status: 422, message: 'Custom quantity', description: MSG });
    return Promise.resolve(new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } }));
  }
  function readChange(opts) { // -> [{ref, qty}] (ref = key, variant id or 1-based line) from change/update bodies
    var out = [], b = opts && opts.body;
    try {
      if (typeof b === 'string') {
        var d = b.trim().charAt(0) === '{' ? JSON.parse(b) : Object.fromEntries(new URLSearchParams(b));
        if (d.updates && typeof d.updates === 'object') Object.keys(d.updates).forEach(function (k) { out.push({ ref: k, qty: +d.updates[k] }); });
        else if (d.id != null || d.line != null) out.push({ ref: d.id != null ? String(d.id) : '#' + d.line, qty: +d.quantity });
        else Object.keys(d).forEach(function (k) { var m = k.match(/^updates\[(.+)\]$/); if (m) out.push({ ref: m[1], qty: +d[k] }); });
      } else if (b instanceof FormData || b instanceof URLSearchParams) {
        if (b.get('id') != null || b.get('line') != null) out.push({ ref: b.get('id') != null ? String(b.get('id')) : '#' + b.get('line'), qty: +b.get('quantity') });
        b.forEach(function (v, k) { var m = k.match(/^updates\[(.+)\]$/); if (m) out.push({ ref: m[1], qty: +v }); });
      }
    } catch (e) {}
    return out;
  }
  function find(items, ref) {
    if (ref.charAt(0) === '#') return items[parseInt(ref.slice(1), 10) - 1];
    return items.filter(function (it) { return it.key === ref || String(it.variant_id) === ref || String(it.id) === ref; })[0];
  }

  window.fetch = function (url, opts) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (opts && opts.__pp) return f.apply(this, arguments);
    var isChange = /\/cart\/(change|update)(\.js)?(\?|$)/.test(u), isAdd = /\/cart\/add(\.js)?(\?|$)/.test(u);
    if (!isChange && !isAdd) return f.apply(this, arguments);
    var self = this, args = arguments;
    if (isAdd) return f.apply(self, args).then(function (res) { setTimeout(function () { sweep().then(function (ch) { if (ch) refreshUI(); }); }, 50); return res; });
    var wanted = readChange(opts);
    if (!wanted.length) return f.apply(self, args);
    return cart().then(function (c) {
      var items = c.items || [];
      var blocked = wanted.some(function (w) {
        var it = find(items, w.ref); if (!it) return false;
        var cq = isChild(it) || !!meta(it);
        return cq && w.qty !== 0 && w.qty !== it.quantity;
      });
      if (blocked) { refreshUI(); return refusal(); }
      return f.apply(self, args).then(function (res) { sweep().then(function (ch) { if (ch) refreshUI(); }); return res; });
    }).catch(function () { return f.apply(self, args); });
  };


  /* cart UI: lock the quantity of custom-quantity lines and show the real item count (22 Oct 2026) */
  var lastCart = null, dTimer = null;
  function decorate(c) {
    if (c) lastCart = c; c = lastCart; if (!c) return;
    var extra = 0;
    (c.items || []).forEach(function (it, i) {
      var child = isChild(it), parent = !!meta(it);
      if (child) extra += it.quantity;
      if (!child && !parent) return;
      ['CartDrawer-Item-', 'CartItem-'].forEach(function (pre) {
        var el = document.getElementById(pre + (i + 1)); if (!el || el.__ppcq === it.key) return;
        el.__ppcq = it.key; el.classList.add('pp-cq-line');
        var q = el.querySelector('quantity-input, quantity-selector');
        if (q && !el.querySelector('.pp-cq-fixed')) {
          q.style.display = 'none';
          var s = document.createElement('span'); s.className = 'pp-cq-fixed';
          s.style.cssText = 'align-self:flex-end;font-size:13px;color:#4b5063';
          s.textContent = child ? it.quantity + ' additional' : 'Custom quantity';
          q.parentNode.insertBefore(s, q);
        }
        if (child) { var rm = el.querySelector('.cart-item__remove, cart-remove-button, a[href*="quantity=0"]'); if (rm) rm.style.display = 'none'; }
      });
    });
    var n = (c.item_count || 0) - extra;
    document.querySelectorAll('cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach(function (b) {
      var t = b.textContent.trim(), want = /^\(\d+\)$/.test(t) ? '(' + n + ')' : String(n);
      if (/^\(?\d+\)?$/.test(t) && t !== want) b.textContent = want;
    });
  }
  function redecorate() { clearTimeout(dTimer); dTimer = setTimeout(function () { cart().then(decorate).catch(function () {}); }, 120); }
  if ('MutationObserver' in window) document.addEventListener('DOMContentLoaded', function () {
    new MutationObserver(function (ms) {
      if (ms.some(function (m) { return m.target.closest && m.target.closest('[id^="CartDrawer"], main-cart, cart-items, cart-count, .cart-count-bubble'); })) redecorate();
    }).observe(document.body, { childList: true, subtree: true });
  });

  function boot() { sweep().then(function (ch) { if (ch) refreshUI(); else redecorate(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
